"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typography = require("@vds-core/typography");
var propTypes = {
  /**
   * Primitive used for the component.
   */
  primitive: _propTypes["default"].oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "span", "p"]),
  /**
   * Viewport the font styling is based on. Desktop and tablet are the same size.
   */
  viewport: _propTypes["default"].oneOf(["desktop", "tablet", "mobile"]),
  /**
   * Content that will be passed to the component.
   */
  children: _propTypes["default"].node,
  /**
   * Color of the text.
   */
  color: _propTypes["default"].oneOf(["#000000", "#FFFFFF", "#ffffff", "#EE0000", "#ee0000", "#F6F6F6", "#f6f6f6", "#D8DADA", "#d8dada", "#A7A7A7", "#a7a7a7", "#6F7171", "#6f7171", "#333333", "#1B1D1F", "#1b1d1f", "#FBE4D7", "#fbe4d7", "#ED7000", "#ed7000", "#C44904", "#c44904", "#4A1C02", "#4a1c02", "#FFF4E0", "#fff4e0", "#FFBC3D", "#ffbc3d", "#523C14", "#523c14", "#D6EEFB", "#d6eefb", "#0096E4", "#0096e4", "#0077B4", "#0077b4", "#002B42", "#002b42", "#D6F2E0", "#d6f2e0", "#00AC3E", "#00ac3e", "#008330", "#003614"]),
  /**
   * The tabIndex of the text.
   */
  tabIndex: _propTypes["default"].number,
  /**
   * Assigns an Id to the component
   */
  id: _propTypes["default"].string,
  /**
   * Adds an aria-labelledby attribute to the component
   */
  ariaLabelledBy: _propTypes["default"].string,
  /**
   * Assigns an testid to the component
   */
  "data-testid": _propTypes["default"].string
};
var defaultProps = {
  primitive: "p",
  viewport: "desktop",
  children: null,
  color: "#000000"
};
var Subtitle = function Subtitle(props) {
  return /*#__PURE__*/_react["default"].createElement(_typography.Subtitle, props);
};
Subtitle.propTypes = propTypes;
Subtitle.defaultProps = defaultProps;
var _default = exports["default"] = Subtitle;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/typography/dist/cjs/components/Subtitle/Subtitle.js
// module id = 1629
// module chunks = 0